/* eslint-disable react/prop-types */
/** @jsxRuntime classic */
/** @jsx jsx */
import { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { jsx, css } from '@emotion/core';
import Popup from "./";
import { Button } from "../";
import { renderHTML } from "../../utils";
import { Warning } from "../../icons";
import { typography } from "../../styles/typography";
const DangerPopup = ({
  open,
  warningText,
  warningIconColor,
  warningDescription,
  confirmText,
  cancelText,
  timing,
  buttonTimingColor,
  onConfirm,
  onCancel,
  popupStyle,
  ...props
}) => {
  const popupActionRef = useRef(null);
  const popupStyles = {
    backgroundColor: '#FFDCD8',
    color: '#E7000F',
    width: 486,
    height: 'max-content',
    ...popupStyle
  };
  const PopupContent = css`
        display: block;
        position: relative;
        color: inherit;
        margin: 24px 58px;
        width: 100%;
    `;
  const PopupInfo = css`
        display: flex;
        justify-content: center;
        align-items: center;
        color: inherit;
        .popup-icon {
            width: 48px;
            height: 44px;
            margin-right: 13px;
        }
        .popup-title {
            ${typography.heading1};
            color: inherit;
        }
    `;
  const PopupWarning = css`
        ${typography.paragraph1};
        text-align: center;
        color: inherit;
    `;
  const PopupAction = css`
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        button {
            min-width: 176px;
            ${typography.paragraph1};
            &.button-confirm {
                &.popup-timing {
                    color: ${buttonTimingColor};
                    background-color: white;
                    border: 1px solid ${buttonTimingColor};
                    box-shadow: none;
                }
            }
        }
    `;
  const onConfirmHandler = () => {
    if (onConfirm) onConfirm();
  };
  const onCancelHandler = () => {
    if (onCancel) onCancel();
  };
  useEffect(() => {
    let timer = null;
    if (open) {
      setTimeout(() => {
        if (popupActionRef.current) {
          const button = popupActionRef.current.querySelector('button.button-confirm');
          if (!button) return;
          const childNode = button.querySelector('.button-text');
          let time = timing;
          button.classList.add('popup-timing');
          button.disabled = true;
          childNode.textContent += ` (${time}s)`;
          timer = setInterval(() => {
            if (time === 0) {
              button.classList.remove('popup-timing');
              button.disabled = false;
              childNode.textContent = confirmText;
              clearInterval(timer);
              return;
            }
            time--;
            childNode.textContent = `${confirmText} (${time}s)`;
          }, 1000);
        }
      }, 0);
    }
    return () => {
      if (open && popupActionRef.current) {
        const button = popupActionRef.current.querySelector('button.button-confirm');
        if (!button) return;
        const childNode = button.querySelector('.button-text');
        setTimeout(() => {
          button.classList.remove('popup-timing');
          button.disabled = false;
          childNode.textContent = confirmText;
        }, 300);
      }
      if (timer) clearInterval(timer);
    };
  }, [open]);
  return jsx(Popup, {
    popupStyle: popupStyles,
    type: 'custom',
    open: open,
    ...props
  }, jsx("div", {
    css: PopupContent
  }, jsx("div", {
    css: PopupInfo
  }, jsx("span", {
    className: 'popup-icon'
  }, jsx(Warning, {
    width: 40,
    height: 40,
    color: warningIconColor,
    viewBox: true
  })), jsx("span", {
    className: 'popup-title'
  }, warningText)), jsx("div", {
    css: PopupWarning
  }, renderHTML(warningDescription)), jsx("div", {
    css: PopupAction,
    ref: popupActionRef
  }, jsx(Button, {
    viewType: 'outlined',
    color: 'danger',
    className: 'button-confirm',
    onClick: onConfirmHandler
  }, confirmText), jsx(Button, {
    viewType: 'outlined',
    color: 'primary',
    onClick: onCancelHandler
  }, cancelText))));
};
DangerPopup.defaultProps = {
  warningText: 'CẢNH BÁO NGUY HIỂM',
  warningIconColor: '#E7000F',
  warningDescription: `Hành động này sẽ xóa tất cả các công việc bên trong dự án và không thể khôi phục.<br/>
    Bạn có chắn chắn muốn xóa dự án này không?`,
  confirmText: 'XÁC NHẬN XOÁ',
  cancelText: 'HUỶ THAO TÁC',
  timing: 10,
  buttonTimingColor: 'rgba(231, 0, 15, 0.5)'
};
DangerPopup.propTypes = {
  /** the title of Popup */
  warningText: PropTypes.string,
  /** the title of Popup */
  warningIconColor: PropTypes.string,
  /** the content to description for warning title */
  warningDescription: PropTypes.string,
  /** the content to display in confirm button */
  confirmText: PropTypes.string,
  /** the content to display in cancel button */
  cancelText: PropTypes.string,
  /** the color of button when timing */
  buttonTimingColor: PropTypes.string,
  /** the period to prevent click confirm button */
  timing: PropTypes.number,
  /** the function run when click confirm button */
  onConfirm: PropTypes.func,
  /** the function run when click cancel button */
  onCancel: PropTypes.func
};
export default /*#__PURE__*/memo(DangerPopup);